export default __webpack_public_path__ + "static/media/slide2.33a486d1.jpg";